import { getConsent, subscribe } from '@zalando-internal/zalando-consent-api';
const CONSENT_NAME = 'client_metrics_aggregator_for_zalando';
export const CMAGCollector = ({ featureKey, flowId, cmagUrl = '/api/cmag', }) => {
    var _a;
    let cmagConsent = false;
    const sentMetrics = new Set();
    // This is to ensure that SPA metrics are attributed to the initial landing page
    const initialRequestUri = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href;
    getConsent(CONSENT_NAME, { useCache: true })
        .then(data => {
        cmagConsent = data.status;
        subscribe(CONSENT_NAME, updatedConsentData => {
            cmagConsent = updatedConsentData.status;
        });
    })
        .catch(() => {
        // ignore
    });
    return metrics => {
        if (!cmagConsent)
            return; // no consent
        const data = {};
        metrics.forEach(met => {
            // CMAG API doesn't accept delta but value, so sent metric should not be sent again to keep percentiles correct
            if (!sentMetrics.has(met.name)) {
                const key = met.name === 'CLS'
                    ? 'cumulativeLayoutShift'
                    : met.name.toLowerCase();
                data[key] = met.name === 'CLS' ? Number(met.value.toFixed(6)) : met.value;
                sentMetrics.add(met.name);
            }
        });
        if (Object.keys(data).length > 0) {
            data.flowId = flowId;
            data.requestUri = initialRequestUri;
            const url = `${cmagUrl}?featureKey=${featureKey}`;
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.log(`Simulating CWV metrics call: ${url}: `, JSON.stringify(data));
                return;
            }
            if (navigator === null || navigator === void 0 ? void 0 : navigator.sendBeacon) {
                navigator.sendBeacon(url, JSON.stringify(data));
            }
        }
    };
};
//# sourceMappingURL=cmagV2Collector.js.map